/**
 * Utilidades globales compartidas por el resto del JS del tema. Carga
 * antes que cualquier otro script (ver layout/theme.liquid) para que
 * esten disponibles sin depender del orden de las demas etiquetas defer.
 */

// Raiz consciente de idioma/mercado (p.ej. '/es/') — Shopify la rellena
// sola en window.Shopify.routes.root. Pegar a '/' a secas en vez de esto
// ignora el idioma/mercado de la pagina actual: cualquier fetch a un
// endpoint de Shopify (cart.js, add.js, section rendering...) devuelve el
// locale por defecto de la tienda en lugar del que esta viendo el
// visitante (bug real que tuvo el cart-drawer, volvia en ingles tras
// cada add-to-cart).
window.themeApiRoot = function () {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
};
